var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "points-mall route-scroll" },
    [
      _c("div", { staticClass: "introduce", on: { click: _vm.toIntroduce } }, [
        _c("img", { attrs: { src: _vm.xh } }),
        _c("span", [_vm._v("广东省医药质量管理协会")]),
      ]),
      _c(
        "pull-refresh",
        {
          attrs: { disabled: _vm.setClinicVisible },
          on: { refresh: _vm.pullLoadData },
          model: {
            value: _vm.pullLoading,
            callback: function ($$v) {
              _vm.pullLoading = $$v
            },
            expression: "pullLoading",
          },
        },
        [
          _c("setClinic", {
            ref: "setClinic",
            attrs: { immediate: "" },
            on: {
              refresh: _vm.loadData,
              open: function ($event) {
                _vm.setClinicVisible = true
              },
              close: function ($event) {
                _vm.setClinicVisible = false
              },
            },
          }),
          _c("mallSearch"),
          _vm.swiperList.length
            ? _c(
                "div",
                { staticClass: "swiper-wrapper" },
                [
                  _c(
                    "van-swipe",
                    {
                      staticClass: "mall-swipe",
                      attrs: { autoplay: 3000 },
                      on: { change: _vm.onSwipeChange },
                    },
                    _vm._l(_vm.swiperList, function (item, index) {
                      return _c(
                        "van-swipe-item",
                        {
                          key: index,
                          on: {
                            click: function ($event) {
                              return _vm.toDetail(item.bannerContent)
                            },
                          },
                        },
                        [
                          _c("img", {
                            staticClass: "swiper-img",
                            attrs: { src: item.imageUrl },
                          }),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.notices.length
            ? _c(
                "div",
                { staticClass: "notice-panel" },
                [
                  _c(
                    "van-notice-bar",
                    { attrs: { "left-icon": "volume-o", scrollable: false } },
                    [
                      _c(
                        "van-swipe",
                        {
                          staticClass: "notice-swipe",
                          attrs: {
                            vertical: "",
                            autoplay: 5000,
                            touchable: false,
                            "show-indicators": false,
                          },
                        },
                        _vm._l(_vm.notices, function (text, index) {
                          return _c("van-swipe-item", { key: index }, [
                            _vm._v(" " + _vm._s(text) + " "),
                          ])
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "ach-header", on: { click: _vm.toPointsDetail } },
            [
              _vm.isVisitor
                ? _c("div", [
                    _c("p", { staticClass: "ach-title" }, [
                      _vm._v("总积分 "),
                      _c("span", [_vm._v("（以实际激活为准）")]),
                    ]),
                    _c("p", { staticClass: "ach-num" }, [_vm._v("5000")]),
                  ])
                : _c("div", [
                    _c("p", { staticClass: "ach-title" }, [_vm._v("总积分")]),
                    _c(
                      "p",
                      { staticClass: "ach-num" },
                      [
                        _c("countTo", {
                          attrs: {
                            separator: "",
                            startVal: _vm.totalPoints,
                            endVal: _vm.totalPoints,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
            ]
          ),
          _vm.categoryList.length
            ? _c(
                "div",
                { staticClass: "category-nav" },
                _vm._l(_vm.categoryList, function (item, idx) {
                  return _c(
                    "div",
                    {
                      key: idx,
                      staticClass: "category-item",
                      on: {
                        click: function ($event) {
                          return _vm.toCategory(item)
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "category-icon",
                        attrs: { src: item.icon },
                      }),
                      _c("div", { staticClass: "category-name" }, [
                        _vm._v(_vm._s(item.navName)),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "discount-panel" },
            [
              _c(
                "div",
                { staticClass: "tabs-warp" },
                _vm._l(_vm.tabList, function (item, index) {
                  return _c(
                    "span",
                    {
                      key: index,
                      class: [
                        _vm.active === index ? "active" : "",
                        "tabs-item",
                      ],
                      on: {
                        click: function ($event) {
                          _vm.active = index
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(item.zoneName) + " ")]
                  )
                }),
                0
              ),
              false
                ? _c(
                    "tabs",
                    {
                      model: {
                        value: _vm.active,
                        callback: function ($$v) {
                          _vm.active = $$v
                        },
                        expression: "active",
                      },
                    },
                    _vm._l(_vm.tabList, function (item, index) {
                      return _c("tab", {
                        key: index,
                        attrs: { title: item.name },
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "goods-grid" },
                _vm._l(_vm.discountGoods, function (goods) {
                  return _c(
                    "div",
                    {
                      key: goods.id,
                      staticClass: "goods-item",
                      on: {
                        click: function ($event) {
                          return _vm.toDetail(goods.drugsId)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "goods-img" },
                        [
                          goods.drugsImage
                            ? _c("van-image", {
                                staticClass: "goods-cover",
                                attrs: {
                                  src: goods.drugsImage.split(",")[0],
                                  fit: "cover",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            padding: "8px 0 0 8px",
                            "min-height": "40px",
                          },
                        },
                        [_c("drugTag", { attrs: { product: goods } })],
                        1
                      ),
                      _c("pointPrice", {
                        attrs: { product: goods, homeStyle: "" },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
              !_vm.discountGoods.length
                ? _c("van-empty", {
                    staticClass: "custom-image",
                    attrs: {
                      image:
                        "https://img01.yzcdn.cn/vant/custom-empty-image.png",
                      description: "暂无商品",
                      "image-size": "80",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("tabbar", { attrs: { curIndex: 0 } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }